import { type LegacyApiError, useApi } from '@omnipresentgroup/api';
import type { UpdateEmploymentRequest } from '@omnipresentgroup/types';
import {
  type UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

export const useEmploymentMutation = ({
  id,
  onSuccess,
  ...options
}: Omit<
  UseMutationOptions<unknown, LegacyApiError, UpdateEmploymentRequest>,
  'mutationFn'
> & { id: string }) => {
  const { PATCH } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => {
      return PATCH({
        path: `${API_BASE}/${API_PATH}/${id}`,
        body: payload,
      });
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: [API_PATH],
        refetchType: 'all',
      });
      onSuccess?.(data, variables, context);
    },
    ...options,
  });
};
